import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const API = {
  verifyPayment: import.meta.env.VITE_VERIFY_PAYMENT,
};

function safe(v) {
  return String(v ?? "").trim();
}

export default function SellerPayCallbackScreen() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const reference = useMemo(
    () => safe(params.get("reference") || params.get("trxref")),
    [params]
  );

  const [msg, setMsg] = useState("Verifying payment…");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!reference) {
      setMsg("");
      setErr("Missing Paystack reference.");
      return;
    }

    let alive = true;

    (async () => {
      try {
        setErr("");
        setMsg("Verifying payment…");

        const url = `${API.verifyPayment}?reference=${encodeURIComponent(reference)}`;
        const r = await fetch(url, { method: "GET" });
        const d = await r.json();

        if (!r.ok) throw new Error(d?.error || "Verification failed.");
        if (!d?.ok) throw new Error("Payment not confirmed yet.");

        if (!alive) return;

        setMsg("✅ Payment verified! Redirecting to login…");
        setTimeout(() => navigate("/login", { replace: true }), 1200);
      } catch (e) {
        if (!alive) return;
        setMsg("");
        setErr(e?.message || "Verification failed.");
      }
    })();

    return () => {
      alive = false;
    };
  }, [reference, navigate]);

  return (
    <div style={{ padding: 40 }}>
      <h2>Payment Verification</h2>
      {msg ? <p>{msg}</p> : null}
      {err ? <p style={{ color: "red" }}>{err}</p> : null}
      <p>
        Reference: <b>{reference || "—"}</b>
      </p>
    </div>
  );
}
